module.exports = __webpack_public_path__ + "static/media/the-how-photographer.f16c99c9.jpg";